import React, { useState } from "react";
import { useAuth } from "../providers/AuthContext";
import ForgotPassword from "./ForgotPassword";

interface LoginProps {
  onSuccess?: () => void;
}

const Login: React.FC<LoginProps> = ({ onSuccess }) => {
  const { login, error, clearError, loading } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();

    try {
      await login(username, password);
      onSuccess?.();
    } catch {
      // Error is handled by AuthContext
    }
  };

  if (showForgotPassword) {
    return (
      <ForgotPassword
        onBack={() => {
          setShowForgotPassword(false);
          clearError();
        }}
        onSuccess={() => {
          setShowForgotPassword(false);
          clearError();
        }}
      />
    );
  }

  return (
    <div className="card" style={{ maxWidth: "400px", margin: "2rem auto" }}>
      <h2 style={{ marginBottom: "1.5rem" }}>Login</h2>

      {error && (
        <div className="error" style={{ marginBottom: "1rem" }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Username</label>
          <input
            type="text"
            className="form-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            minLength={3}
            autoComplete="username"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="current-password"
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          style={{ width: "100%", marginTop: "0.5rem" }}
          disabled={loading}
        >
          {loading ? "..." : "Login"}
        </button>
      </form>

      <p style={{ marginTop: "1rem", textAlign: "center", color: "var(--color-text-secondary)" }}>
        <button
          type="button"
          onClick={() => {
            setShowForgotPassword(true);
            clearError();
          }}
          style={{
            background: "none",
            border: "none",
            color: "var(--color-primary)",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          Forgot Password?
        </button>
      </p>

      <p style={{ marginTop: "0.5rem", textAlign: "center", color: "var(--color-text-secondary)", fontSize: "0.875rem" }}>
        Don't have an account? Contact a commissioner.
      </p>
    </div>
  );
};

export default Login;
